<template>
  <div :class="`clientLogo clientLogo--${type}${!hasLogo ? ' clientLogo--noLogo' : ''}`">
    <img v-if="hasLogo" class="clientLogo__img" :src="clientLogo" />
    <span class="clientLogo__text" v-else>Please upload logo</span>
  </div>
</template>

<script>

import { API_URL } from '@/config'

export default {
  name: 'ClientLogo',
  props: {
    path: String,
    type: String
  },
  created () {
    /*
    const img = new Image()
    const that = this
    img.onload = () => {
      that.imageLoaded = true
    }
    img.src = `http://otomo.local/${this.path}`
    */
  },
  computed: {
    hasLogo () {
      return this.path && this.path.length > 0
    },
    clientLogo () {
      return API_URL + this.path.substring(1)
    }
  },
  data: () => ({
    imageLoaded: false
  })
}
</script>

<style lang="scss">
    @import "../../scss/_variables";
    .clientLogo {
      height: 200px;
      width: 200px;
      display: flex;
      align-items: center;
      &--noLogo {
        background-color: #FFF;
        border: 3px dashed #999;
        margin-bottom: 15px;
      }
      &__text {
        transition: color $transition;
        color: #999;
        display: block;
        text-align: center;
        width: 100%;
        font-size: 30px;
        line-height: 40px;
        padding: 0 20px;
        text-decoration: none;
      }
      &__img {
        max-width: 100%;
        border: 1px solid $backgroundBrand;
        max-width: 200px;
        max-height: 200px;
      }
      &--small {
        max-height: 50px;
        max-width: 50px;
        img {
          max-height: 50px;
          max-width: 50px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/ClientLogo/client-logo.vue